<template>
  <div id="app">
    <div class="tab" style="border:none">
      <ul>
        <li><span class="active">预约进度</span></li>
        <li><span ></span></li>
      </ul>
 
    </div>

    <div v-for="(item,key) in appointments" :key="key" class="process">
      <div class="info">
        <div class="title">{{item.title}}</div>
        <div class="field">申请人：{{item.applicant}}</div>
        <div class="field">联系方式：{{item.tel}}</div>
        <div class="field">申请时间：{{item.applyDate}}</div>
      </div>
       <div v-if="item.status==0" class="status green">受理中</div>
      <div v-if="item.status==1" class="status blue">已受理</div>
      <div class="clear_both"></div>
    </div> 


  </div>
</template>
<style scoped src="../../../static/css/Common.css"></style>
<style scoped src="../../../static/css/Appointment.css"></style>
<style scoped src="../../../static/css/AppointmentProcess.css"></style>

<script>
import {appointmentListApi} from '@/service/allApi'
export default {
  data(){
    return {
      appointments:[]
    }
  },
  mounted(){
    this.loadData()
  },
  methods:{
    async loadData(){
      const res = await appointmentListApi()
      if(res.data.code == 100){
        this.appointments = res.data.list
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/iframe/AppointmentProcess.vue